import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;

export const UsersContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const UsersFirstContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const AreaTitle = styled.h2`
  margin: 0;
  color: #e6aa3a;
  font-size: 28px;
  font-weight: 600;
`;

export const AddClient = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #ffc300;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(230, 170, 58, 0.4);
  }
`;

export const Users = styled.div``;

export const SearchBar = styled.div`
  display: flex;
  margin-bottom: 25px;

  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    transition: all 0.3s;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &:focus {
      outline: none;
      border-color: #e6aa3a;
      box-shadow: 0 0 0 3px rgba(230, 170, 58, 0.2);
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 16px;
    text-align: left;
    white-space: nowrap;
    vertical-align: middle;
  }

  thead tr {
    background-color: rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #e6aa3a;
    th {
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  tbody tr {
    color: #ddd;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }
`;

export const TableHeader = styled.thead``;
export const TableRow = styled.tr``;
export const TableHeaderCell = styled.th``;
export const TableBody = styled.tbody``;
export const TableCell = styled.td``;

export const OptionsGroup = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;

  button {
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    font-size: 18px;
    transition: all 0.2s;

    &:hover {
      color: #e6aa3a;
      transform: scale(1.2);
    }
  }
  .delete-btn:hover {
    color: #e74c3c;
  }
`;

export const ViewPermissionsButton = styled.button`
  background: transparent;
  border: 1px solid #e6aa3a;
  color: #e6aa3a;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #e6aa3a;
    color: #111;
    box-shadow: 0 0 15px rgba(230, 170, 58, 0.5);
  }
`;
